<template>
  <div class="share-container" ref="shareWrap">
    <div class="share-btn" @click="toggleShare">
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
      </svg>
    </div>

    <!-- 全屏分享弹窗 -->
    <div v-if="showShare" class="share-overlay" @click="closeShare">
      <div class="share-modal" @click.stop>
        <div class="share-modal-header">
          <span class="share-title">分享</span>
          <span class="close-btn" @click="closeShare">✕</span>
        </div>
        <div class="share-modal-body">
          <img 
            src="@/assets/share.jpg" 
            alt="分享图片" 
            class="share-image"
            @click="handleImageClick"
          />
        </div>
        <div class="share-modal-footer">
          <button class="share-action-btn" @click="handleDownload">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            下载图片
          </button>
          <button class="share-action-btn" @click="closeShare">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
            关闭
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareButton',
  data() {
    return {
      showShare: false
    };
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscClose);
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscClose);
  },
  methods: {
    toggleShare() {
      this.showShare = !this.showShare;
      if (this.showShare) {
        document.body.style.overflow = 'hidden';
        // 打开弹窗挂载全局点击监听
        this.$nextTick(() => {
          document.addEventListener('click', this.handleClickOutside);
        });
      } else {
        document.body.style.overflow = '';
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    // 统一关闭弹窗方法
    closeShare() {
      this.showShare = false;
      document.body.style.overflow = '';
      document.removeEventListener('click', this.handleClickOutside);
    },
    // 点击弹窗外部区域关闭
    handleClickOutside(event) {
      const wrap = this.$refs.shareWrap;
      if (!wrap.contains(event.target)) {
        this.closeShare();
      }
    },
    // ESC快捷键关闭
    handleEscClose(event) {
      if (event.key === 'Escape' && this.showShare) {
        this.closeShare();
      }
    },
    handleImageClick() {
      this.handleDownload();
    },
    handleDownload() {
      // 下载图片
      const link = document.createElement('a');
      link.download = 'share.jpg';
      link.href = require('@/assets/share.jpg');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.share-container {
  position: fixed;
  right: 6px;
  bottom: 275px;
  z-index: 9999;
}

/* 按钮与 Tips 保持统一风格 */
.share-btn {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  border-radius: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: none;
}

.share-btn:hover {
  transform: scale(1.15);
  box-shadow: 0 0 12px rgba(255, 180, 180, 0.3);
}

.share-btn svg {
  width: 24px;
  height: 24px;
  stroke: #fff;
}

/* ===== 全屏遮罩 ===== */
.share-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: overlay-fade-in 0.3s ease;
}

/* ===== 弹窗主体 ===== */
.share-modal {
  background: rgba(255, 250, 240, 0.92);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 16px;
  padding: 24px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modal-pop-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* ===== 头部 ===== */
.share-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.share-title {
  font-size: 18px;
  font-weight: 500;
  color: var(--font-color-1);
  letter-spacing: 0.5px;
}

.close-btn {
  cursor: pointer;
  font-size: 24px;
  color: var(--font-color-1);
  opacity: 0.5;
  transition: all 0.3s ease;
  line-height: 1;
}

.close-btn:hover {
  transform: rotate(90deg) scale(1.2);
  opacity: 1;
}

/* ===== 图片区域（居中显示） ===== */
.share-modal-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  overflow: hidden;
}

.share-image {
  max-width: 100%;
  max-height: 65vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.share-image:hover {
  transform: scale(1.02);
}

/* ===== 底部按钮 ===== */
.share-modal-footer {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 16px;
  flex-shrink: 0;
}

.share-action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 24px;
  border: none;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px);
  color: var(--font-color-1);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  font-weight: 500;
}

.share-action-btn:hover {
  background: rgba(255, 255, 255, 0.7);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.share-action-btn:active {
  transform: translateY(0);
}

.share-action-btn svg {
  stroke: var(--font-color-1);
  flex-shrink: 0;
}

/* ===== 动画 ===== */
@keyframes overlay-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modal-pop-in {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ===== 移动端适配 ===== */
@media only screen and (max-width: 768px) {
  .share-modal-header {
    margin-bottom: 12px;
  }

  .share-title {
    font-size: 16px;
  }

  .close-btn {
    font-size: 20px;
  }

  .share-image {
    max-height: 55vh;
  }

  .share-action-btn {
    padding: 8px 16px;
    font-size: 13px;
  }

  .share-action-btn svg {
    width: 18px;
    height: 18px;
  }
}

/* 小屏手机适配 */
@media only screen and (max-width: 480px) {
  .share-image {
    max-height: 50vh;
  }

  .share-modal-footer {
    flex-direction: column;
    gap: 8px;
  }

  .share-action-btn {
    justify-content: center;
    padding: 10px 12px;
  }
}
</style>